import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { isNil } from 'lodash-es';
import { AgentData } from '@api/models/AgentApi/Contract/agent-data';
import { AgentsState } from '../../../state/agents.state';


/**
 * Retrieving Agent Details (Resolver)
 */
@Injectable({
    providedIn: 'root',
})
export class AgentDetailResolverService {
    readonly #agentsState: AgentsState = inject(AgentsState);

    public resolve(
        route: ActivatedRouteSnapshot,
    ): Observable<AgentData> | Observable<never> {
        const slrId: number = +route.paramMap.get(RoutingQueryParamsName.SlrId);

        return isNil(slrId) || slrId === 0 ? null : this.#agentsState.requestAgentData(slrId).pipe(take(1));
    }
}
